var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"eventRaceList",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-3"},_vm._l((_vm.listData),function(item,index){return _c('RaceItem',{key:index,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }